import { render } from "./UsersTable.vue?vue&type=template&id=6e05e788&ts=true"
import script from "./UsersTable.ts?vue&type=script&lang=ts"
export * from "./UsersTable.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__